import type { ExecutionStatus, IncidentStatus, AutomationStatus } from '@adweb/shared';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

type Status = ExecutionStatus | IncidentStatus | AutomationStatus | 'unknown';

const COLORS: Record<string, string> = {
  RUNNING: 'bg-blue-100 text-blue-800',
  SUCCEEDED: 'bg-emerald-100 text-emerald-800',
  FAILED: 'bg-red-100 text-red-800',
  PARTIAL: 'bg-amber-100 text-amber-800',
  OPEN: 'bg-red-100 text-red-800',
  IN_PROGRESS: 'bg-amber-100 text-amber-800',
  RESOLVED: 'bg-emerald-100 text-emerald-800',
  DRAFT: 'bg-slate-100 text-slate-700',
  ACTIVE: 'bg-emerald-100 text-emerald-800',
  PAUSED: 'bg-amber-100 text-amber-800',
  RETIRED: 'bg-slate-100 text-slate-500',
  unknown: 'bg-slate-100 text-slate-600',
};

export function StatusBadge({ status }: { status: Status }) {
  const { t } = useTranslation();
  const color = COLORS[status] ?? COLORS.unknown!;
  const label = t(`status.${status}`, { defaultValue: status });
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        color,
      )}
    >
      {label}
    </span>
  );
}
